let drawerItems = '';

// Update qty from drawer ##########################################################
// ###############################################################################

function update_drawer_qty(e) {
  // Prevent defaults action (used to avoid refresh on form submit)
  e.preventDefault();

  // e.target is the element of the event and allow us to access element data such as dataset.
  const form = document.getElementById(e.target.id); // Find the element by its data-scr

  // Get current quantity from dataset data-qty
  const qty = parseInt(form.dataset.qty);

  // Get action type (plus or minus)
  const action = form.dataset.action;

  // Update quantity based on action type
  const updatedQty = action === 'minus' ? qty - 1 : qty + 1;

  // Get current id from dataset insead of id
  const id = form.dataset.id;

  let formData = { id: id, quantity: updatedQty };

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      const resp = response.json();
      const status = response.status;

      if (status === 200) {
        updateDrawer().then((template) => {
          // Await the template build and then push the code into the drawer body
          //drawerBody.innerHTML = '';

          //drawerBody.innerHTML = template;

          const drawerFormsMinus = document.querySelectorAll('.quantity__button--decrement');

          if (drawerFormsMinus.length > 0) {
            drawerFormsMinus.forEach((form) => {
              form.addEventListener('click', update_drawer_qty);
            });
          }

          const drawerFormsPlus = document.querySelectorAll('.quantity__button--increment');

          if (drawerFormsPlus.length > 0) {
            drawerFormsPlus.forEach((form) => {
              form.addEventListener('click', update_drawer_qty);
            });
          }

          const removeDrawerItem = document.querySelectorAll('.remove_drawer_item');

          if (removeDrawerItem.length > 0) {
            removeDrawerItem.forEach((form) => {
              form.addEventListener('click', remove_drawer_item);
            });
          }
        });
      }
      console.log(status);
    })
    .catch((error) => {
      console.error(error);
    });
}

// Remove Drawer item ############################################################
// ###############################################################################

function remove_drawer_item(e) {
  e.preventDefault();
  // Get id from dataset
  const id = e.target.dataset.id;
  let formData = { id: id, quantity: 0 };

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .then((response) => {
      const resp = response;
      updateDrawer().then(() => {
        const drawerFormsMinus = document.querySelectorAll('.quantity__button--decrement');

        if (drawerFormsMinus.length > 0) {
          drawerFormsMinus.forEach((form) => {
            form.addEventListener('click', update_drawer_qty);
          });
        }

        const drawerFormsPlus = document.querySelectorAll('.quantity__button--increment');

        if (drawerFormsPlus.length > 0) {
          drawerFormsPlus.forEach((form) => {
            form.addEventListener('click', update_drawer_qty);
          });
        }

        const removeDrawerItem = document.querySelectorAll('.remove_drawer_item');

        if (removeDrawerItem.length > 0) {
          removeDrawerItem.forEach((form) => {
            form.addEventListener('click', remove_drawer_item);
          });
        }
      });
      get_cart();
    })
    .catch((error) => {
      console.error(error);
    });
}

/* Create drawer templates logic */
const drawerBody = document.getElementById('drawer_body');

const generateCartItems = function (element, content) {
  if (element.textContent.length > 0) {
    return (element.textContent = content);
  } else {
    return element.remove();
  }
};

const generateCartLinks = function (elements, array) {
  elements.forEach(function (link) {
    link.href = array;
  });
};

// Create item from HTML template
function buildItem(items) {
  const cartContainer = document.querySelector('#drawer_body');
  const cartTemplate = document.querySelector('#cart_item').content.querySelector('.cart-item');
  const cartFragment = new DocumentFragment();

  items.forEach(function (item) {
    let template = cartTemplate.cloneNode(true);
    let normalizedPrice = parseFloat(item.price / 100).toFixed(2);

    generateCartLinks(template.querySelectorAll('.cart-item__link'), item.url);
    template.querySelector('.cart-item__image').src = item.featured_image.url;
    generateCartItems(template.querySelector('.full-unstyled-link'), item.product_title);
    generateCartItems(template.querySelector('.cart-item__price'), normalizedPrice);
    generateCartItems(template.querySelector('.quantity__input'), item.quantity);
    template.querySelector('.quantity__button--decrement').id = item.variant_id + `_minus`;
    template.querySelector('.quantity__button--decrement').dataset.id = item.variant_id;
    template.querySelector('.quantity__button--decrement').dataset.qty = item.quantity;
    template.querySelector('.quantity__input').id = `drawer_item_qty-` + item.variant_id;
    template.querySelector('.quantity__button--increment').id = item.variant_id + `_plus`;
    template.querySelector('.quantity__button--increment').dataset.id = item.variant_id;
    template.querySelector('.quantity__button--increment').dataset.qty = item.quantity;
    template.querySelector('.remove_drawer_item').dataset.id = item.variant_id;

    return cartFragment.appendChild(template);
  });

  cartContainer.appendChild(cartFragment);
}

// Create  drawer items template
async function updateDrawer() {
  // Fetch cart.js
  const response = await fetch('/cart.js');
  const json = await response.json();
  const items = json.items; // Return only items object
  let itemSubtotal = '';

  const drawerBody = document.querySelector('#drawer_body');
  const drawerFooter = document.getElementById('drawer_footer');
  const drawerEmpty = document.querySelector('.cart-drawer__empty');
  const cartBadge = document.querySelector('.js-cart-count');

  drawerBody.innerHTML = '';
  // Return items template
  if (items.length > 0) {
    itemSubtotal = items
      .map((item) => item.final_line_price)
      .reduce((previousValue, currentValue) => previousValue + currentValue, 0);

    let itemSubtotalNormalize = parseFloat(itemSubtotal / 100).toFixed(2);
    let difference = 150 - itemSubtotalNormalize;

    let itemsQuantity = items
      .map((item) => item.quantity)
      .reduce((previousValue, currentValue) => previousValue + currentValue, 0);

    drawerFooter.querySelector('.cart-summary__subtotal').innerHTML = itemSubtotalNormalize;
    drawerFooter.querySelector('.cart-summary__difference').innerHTML = difference;
    if (itemSubtotalNormalize > 150) {
      drawerFooter.querySelector('.caption--shipping').classList.add('hidden');
    } else {
      drawerFooter.querySelector('.caption--shipping').classList.remove('hidden');
    }

    buildItem(items);
    drawerEmpty.setAttribute('style', 'display: none;');
    drawerFooter.removeAttribute('style');
    cartBadge.classList.remove('hidden');
    cartBadge.innerHTML = itemsQuantity;

    // Event snippet per Inizio procedura di pagamento conversion
    drawerFooter.querySelector('#goto_checkout').addEventListener('click', () => {
      // gtag('event', 'conversion', {
      //   send_to: 'AW-961033686/phRrCOSCqIAYENbroMoD',
      //   value: itemSubtotalNormalize,
      //   currency: Shopify.currency.active,
      // });
      console.log('inizio checkout drawer');
      setTimeout(() => {
        window.location.href = '/checkout';
      }, 1000);
    });
  } else {
    drawerEmpty.removeAttribute('style');
    drawerFooter.setAttribute('style', 'display: none;');
    return;
  }
}

updateDrawer().then((template) => {
  // Await the template build and then push the code into the drawer body
  //drawerBody.innerHTML = template;

  const drawerFormsMinus = document.querySelectorAll('.quantity__button--decrement');

  if (drawerFormsMinus.length > 0) {
    drawerFormsMinus.forEach((form) => {
      form.addEventListener('click', update_drawer_qty);
    });
  }

  const drawerFormsPlus = document.querySelectorAll('.quantity__button--increment');

  if (drawerFormsPlus.length > 0) {
    drawerFormsPlus.forEach((form) => {
      form.addEventListener('click', update_drawer_qty);
    });
  }

  const removeDrawerItem = document.querySelectorAll('.remove_drawer_item');

  if (removeDrawerItem.length > 0) {
    removeDrawerItem.forEach((form) => {
      form.addEventListener('click', remove_drawer_item);
    });
  }
});

// Drawer handler + drawer update trigger on click
const drawer = document.getElementById('drawer');
const body = document.querySelector('body');
const openDrawer = document.getElementById('open_drawer');
const openDrawerMobile = document.getElementById('open_drawer_mobile');
const closeDrawer = document.getElementById('close_drawer');
const mediaQuery = window.matchMedia('(min-width: 1024px)');
const drawerOverlay = document.querySelector('.cart-drawer__overlay');

function drawerHandler() {
  if (!drawer.classList.contains('is-visible')) {
    drawer.classList.toggle('is-visible');
    updateDrawer().then((template) => {
      // Await the template build and then push the code into the drawer body
      //drawerBody.innerHTML = template;

      const drawerFormsMinus = document.querySelectorAll('.quantity__button--decrement');

      if (drawerFormsMinus.length > 0) {
        drawerFormsMinus.forEach((form) => {
          form.addEventListener('click', update_drawer_qty);
        });
      }

      const drawerFormsPlus = document.querySelectorAll('.quantity__button--increment');

      if (drawerFormsPlus.length > 0) {
        drawerFormsPlus.forEach((form) => {
          form.addEventListener('click', update_drawer_qty);
        });
      }

      const removeDrawerItem = document.querySelectorAll('.remove_drawer_item');

      if (removeDrawerItem.length > 0) {
        removeDrawerItem.forEach((form) => {
          form.addEventListener('click', remove_drawer_item);
        });
      }
    });
    body.classList.toggle('overflow');
  } else {
    updateDrawer().then((template) => {
      // Await the template build and then push the code into the drawer body
      //drawerBody.innerHTML = template;

      const drawerFormsMinus = document.querySelectorAll('.quantity__button--decrement');

      if (drawerFormsMinus.length > 0) {
        drawerFormsMinus.forEach((form) => {
          form.addEventListener('click', update_drawer_qty);
        });
      }

      const drawerFormsPlus = document.querySelectorAll('.quantity__button--increment');

      if (drawerFormsPlus.length > 0) {
        drawerFormsPlus.forEach((form) => {
          form.addEventListener('click', update_drawer_qty);
        });
      }

      const removeDrawerItem = document.querySelectorAll('.remove_drawer_item');

      if (removeDrawerItem.length > 0) {
        removeDrawerItem.forEach((form) => {
          form.addEventListener('click', remove_drawer_item);
        });
      }
    });
    body.classList.toggle('overflow');
  }
}

if (openDrawer) {
  openDrawer.addEventListener('click', drawerHandler);
}

if (openDrawerMobile) {
  openDrawerMobile.addEventListener('click', drawerHandler);
}

if (closeDrawer) {
  closeDrawer.addEventListener('click', function () {
    drawer.classList.toggle('is-visible');
    body.classList.toggle('overflow');
  });
}

if (drawerOverlay) {
  drawerOverlay.addEventListener('click', function () {
    drawer.classList.toggle('is-visible');
    body.classList.toggle('overflow');
  });
}
